import { Outlet } from "react-router-dom"

export function CollectionLayout() {
  return <Outlet />
}
